import React from 'react';

import cn from 'classnames';
import startCase from 'lodash/startCase';
import {
  MdAccessTimeFilled,
  MdCancel,
  MdCheck,
  MdCheckCircle,
  MdPlayCircle,
  MdStar,
} from 'react-icons/md';

import Text from '../Text';
import styles from './StatusTag.scss';

const EmptyIcon = () => null;

export enum StatusProp {
  STARTED = 'started',
  NOT_STARTED = 'notStarted',
  INPROGRESS = 'inProgress',
  COMPLETED = 'completed',
  AWARDED = 'awarded',
  PENDING = 'pending',
  DECLINED = 'declined',
  APPROVED = 'approved',
}

type StatusType = `${StatusProp}`;

export interface StatusTagProps {
  status: StatusType | (string & {});
}

function StatusTag(props: StatusTagProps) {
  const status = props.status;

  const label = props.status;

  const icons = {
    awarded: MdStar,
    pending: MdAccessTimeFilled,
    started: MdPlayCircle,
    inProgress: MdPlayCircle,
    completed: MdCheck,
    approved: MdCheckCircle,
    declined: MdCancel,
  };

  const Icon =
    status in icons ? icons[status as keyof typeof icons] : EmptyIcon;

  return (
    <div
      data-status={status}
      className={cn(styles.statusContainer, styles[props.status], {
        [styles.noIcon]: Icon === EmptyIcon,
      })}
    >
      <Icon />

      <Text font="body-body-4">{startCase(label)}</Text>
    </div>
  );
}

export default StatusTag;
